import { IRoute } from '../../types';
import { Campaign, NewCampaign } from './Campaign';
import CampaignDetails from './Campaign/containers/CampaignDetails';
import EditCampaign from './Campaign/containers/EditCampaign';
import Logout from './Logout';

const ROUTES: IRoute[] = [
  {
    path: '/',
    to: '/*',
    label: 'Campaign',
    element: <Campaign />,
    index: true,
  },
  {
    path: '/campaign/new',
    to: '/campaign/new',
    label: 'New Campaign',
    element: <NewCampaign />,
  },
  {
    path: '/campaign/:id',
    to: '/campaign/:id',
    label: 'Campaign Details',
    element: <CampaignDetails />,
  },
  {
    path: '/campaign/:id/edit',
    to: '/campaign/:id/edit',
    label: 'Edit Campaign',
    element: <EditCampaign />,
  },
  {
    path: '/logout',
    to: '/logout/*',
    label: 'Logout',
    element: <Logout />,
  },
];

export default ROUTES;
